import React, { useEffect, useState } from 'react';
import { getUserBrowserStorage } from '../constants';
import Services from '../services/services';
import SharedEventPage from './SharedEventPage';
import InvitedEventPage from './InvitedEventPage';

import { useParams, useHistory } from 'react-router-dom';

function ShareEventContainer() {
  let { eventId, eventUniqueNo } = useParams();
  const userDetails = JSON.parse(getUserBrowserStorage('userDetails'));
  const isLogin = JSON.parse(getUserBrowserStorage('isLogin'));

  const [streamDetails, setStreamDetails] = useState({});

  const getInviteDetails = async (userId, eventId) => {
    //single event data
    try {
      const res = await Services.single_event_details(
        userId,
        eventId,
        eventUniqueNo
      );
      if (res.data.responseCode === 200) {
        setStreamDetails(res.data.listOfHostEvents[0]);
      }
    } catch (error) {
      return { eventStatus: 'Please check your internet' };
    }
  };

  useEffect(() => {
    if (userDetails?.userId) {
      getInviteDetails(userDetails?.userId, eventId);
    }
  }, []);

  const renderFunc = (streamDetails) => {
    const isDataAvailable = streamDetails?.eventId;
    if (isDataAvailable) {
      return (
        <InvitedEventPage
          streamDetails={streamDetails}
          eventId={eventId}
          eventUniqueNo={eventUniqueNo}
          userDetails={userDetails}
          isLogin={isLogin}
        />
      );
    } else {
      return (
        <SharedEventPage
          eventId={eventId}
          eventUniqueNo={eventUniqueNo}
          userDetails={userDetails}
          isLogin={isLogin}
        />
      );
    }
  };

  return renderFunc(streamDetails);
}

export default ShareEventContainer;
